import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), {}, {
    children: /*#__PURE__*/_jsxs("g", {
      fill: "currentColor",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M16 22.5c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5m0-2a.5.5 0 1 0 .002 1.002A.5.5 0 0 0 16 20.5M19.762 19.238a.504.504 0 0 1-.378-.172C18.52 18.071 17.286 17.5 16 17.5s-2.52.571-3.384 1.566a.501.501 0 0 1-.755-.656A5.492 5.492 0 0 1 16 16.5c1.576 0 3.085.696 4.14 1.91a.501.501 0 0 1-.378.828"
      }), /*#__PURE__*/_jsx("path", {
        d: "M21.895 17.11a.5.5 0 0 1-.369-.162c-1.422-1.552-3.436-2.443-5.526-2.443s-4.104.891-5.526 2.443a.5.5 0 0 1-.738-.676A8.523 8.523 0 0 1 16 13.505c2.37 0 4.652 1.01 6.264 2.768a.5.5 0 0 1-.369.837"
      }), /*#__PURE__*/_jsx("path", {
        d: "M24.02 14.983a.495.495 0 0 1-.364-.158c-2.01-2.144-4.73-3.325-7.653-3.325s-5.641 1.181-7.652 3.326a.5.5 0 1 1-.729-.685c2.202-2.348 5.179-3.641 8.381-3.641s6.179 1.293 8.381 3.641a.5.5 0 0 1-.364.842"
      })]
    })
  }));
};
export default SvgComponent;